import {
  PENDING,
  FULFILLED,
  REJECTED,
  getGroupUrl,
  manageGroups,
  getPreferences,
  setPreferences,
  resetPwdUrl,
  getKpi,
  setKpi,
  getMaintainanceUrl,
  setMaintainanceUrl,
  setAlertUrl,
  getAlertSettingUrl,
  getSegmentApplicationsUrl,
  getProfileDetails,
  deleteProfileDetails,
  getProfileByStatusURL,
  profileBackgroundInprogress,
  activateProfile,
  groupServiceAPIUrl,
  signalDetailAPIUrl,
  getActiveCdsProfileUrl,
  sendOTPURL,
  tickerUrl,
  pointOfInterestURL,
} from '../../Helpers/Constants';

// group actions
export function getGroups(data) {
  return {
    types: [
      `GET_GROUP_${PENDING}`,
      `GET_GROUP_${FULFILLED}`,
      `GET_GROUP_${REJECTED}`,
    ],
    method: 'GET',
    url: getGroupUrl,
    queryParams: {
      userId: data.userId,
      subGroupId: data.subGroupId,
    },
    data,
  };
}

export function addGroups(data) {
  return {
    types: [
      `ADD_GROUP_${PENDING}`,
      `ADD_GROUP_${FULFILLED}`,
      `ADD_GROUP_${REJECTED}`,
    ],
    method: 'POST',
    url: manageGroups,
    payload: {},
    data,
  };
}

// group pois
export function getPois() {
  return {
    types: [
      `GET_POIS_${PENDING}`,
      `GET_POIS_${FULFILLED}`,
      `GET_POIS_${REJECTED}`,
    ],
    method: 'GET',
    url: pointOfInterestURL,
  };
}

export function addPois(data) {
  return {
    types: [
      `ADD_POIS_${PENDING}`,
      `ADD_POIS_${FULFILLED}`,
      `ADD_POIS_${REJECTED}`,
    ],
    method: 'POST',
    url: pointOfInterestURL,
    payload: {},
    data,
  };
}

export function editPois(data, METHOD) {
  return {
    types: [
      `EDIT_POIS_${PENDING}`,
      `EDIT_POIS_${FULFILLED}`,
      `EDIT_POIS_${REJECTED}`,
    ],
    method: METHOD === 'POST' ? 'POST' : 'PUT',
    url: pointOfInterestURL,
    payload: {},
    data,
  };
}

export function getEditPois(data) {
  return {
    types: [
      `GET_EDIT_POIS_${PENDING}`,
      `GET_EDIT_POIS_${FULFILLED}`,
      `GET_EDIT_POIS_${REJECTED}`,
    ],
    method: 'GET',
    url: `${pointOfInterestURL}/${data.id}`,
    payload: {},
    data,
  };
}

export function deletePois(data) {
  return {
    types: [
      `DELETE_POIS_${PENDING}`,
      `DELETE_POIS_${FULFILLED}`,
      `DELETE_POIS_${REJECTED}`,
    ],
    method: 'DELETE',
    url: `${pointOfInterestURL}/${data.id}`,
    payload: {},
    data,
  };
}

// alert preference
export function getAlertPrefernce(data) {
  return {
    types: [
      `GET_USER_ALERT_PREFERENCE_${PENDING}`,
      `GET_USER_ALERT_PREFERENCE_${FULFILLED}`,
      `GET_USER_ALERT_PREFERENCE_${REJECTED}`,
    ],
    method: 'GET',
    url: getPreferences,
    queryParams: {
      userId: data.userId,
    },
    data,
  };
}

export function addAlertPreference(data) {
  return {
    types: [
      `ADD_USER_ALERT_PREFERENCE_${PENDING}`,
      `ADD_USER_ALERT_PREFERENCE_${FULFILLED}`,
      `ADD_USER_ALERT_PREFERENCE_${REJECTED}`,
    ],
    method: 'POST',
    url: setPreferences,
    payload: {},
    data,
  };
}
// change password

export function changePassword(data) {
  return {
    types: [
      `CHANGE_PASSWORD_${PENDING}`,
      `CHANGE_PASSWORD_${FULFILLED}`,
      `CHANGE_PASSWORD_${REJECTED}`,
    ],
    method: 'POST',
    url: resetPwdUrl,
    payload: {},
    data,
  };
}

export function getScalingFactor(data) {
  return {
    types: [
      `GET_SCALING_FACTOR_${PENDING}`,
      `GET_SCALING_FACTOR_${FULFILLED}`,
      `GET_SCALING_FACTOR_${REJECTED}`,
    ],
    method: 'GET',
    url: getKpi,
    payload: {},
    queryParams: {
      userId: data.userId,
    },
    data,
  };
}
export function addScalingFactor(data) {
  return {
    types: [
      `ADD_SCALING_FACTOR_${PENDING}`,
      `ADD_SCALING_FACTOR_${FULFILLED}`,
      `ADD_SCALING_FACTOR_${REJECTED}`,
    ],
    method: 'POST',
    url: setKpi,
    payload: {},
    data,
  };
}

// alert setting
export function getAlertSettings(data) {
  return {
    types: [
      `GET_ALERT_SETTINGS_${PENDING}`,
      `GET_ALERT_SETTINGS_${FULFILLED}`,
      `GET_ALERT_SETTINGS_${REJECTED}`,
    ],
    method: 'GET',
    url: getAlertSettingUrl,
    payload: {},
    queryParams: {
      userId: data.userId,
    },
    data,
  };
}
export function addAlertSettings(data) {
  return {
    types: [
      `ADD_ALERT_SETTINGS_${PENDING}`,
      `ADD_ALERT_SETTINGS_${FULFILLED}`,
      `ADD_ALERT_SETTINGS_${REJECTED}`,
    ],
    method: 'POST',
    url: setAlertUrl,
    payload: {},
    data,
  };
}

export function setMaintainanceStatus() {
  return {
    types: [
      `SET_MAINTAINANCE_STATUS_${PENDING}`,
      `SET_MAINTAINANCE_STATUS_${FULFILLED}`,
      `SET_MAINTAINANCE_STATUS_${REJECTED}`,
    ],
    method: 'POST',
    url: setMaintainanceUrl,
    payload: {},
  };
}

export function getMaintainanceStatus(data) {
  return {
    types: [
      `GET_MAINTAINANCE_STATUS_${PENDING}`,
      `GET_MAINTAINANCE_STATUS_${FULFILLED}`,
      `GET_MAINTAINANCE_STATUS_${REJECTED}`,
    ],
    method: 'GET',
    url: getMaintainanceUrl,
    payload: {},
    data,
  };
}

// CDS
export function getSegmentApplications(data) {
  return {
    types: [
      `GET_APPLICATION_SEGMENT_${PENDING}`,
      `GET_APPLICATION_SEGMENT_${FULFILLED}`,
      `GET_APPLICATION_SEGMENT_${REJECTED}`,
    ],
    method: 'GET',
    url: getSegmentApplicationsUrl,
    data,
  };
}

// signal Detail API Url
export function getSignalDetailApi(data) {
  return {
    types: [
      `GET_SIGNAL_DETAIL_API_${PENDING}`,
      `GET_SIGNAL_DETAIL_API_${FULFILLED}`,
      `GET_SIGNAL_DETAIL_API_${REJECTED}`,
    ],
    method: 'GET',
    url: signalDetailAPIUrl,
    data,
  };
}

// group Service API Url
export function getGroupDetailApi(data) {
  return {
    types: [
      `GET_GROUP_DETAIL_API_${PENDING}`,
      `GET_GROUP_DETAIL_API_${FULFILLED}`,
      `GET_GROUP_DETAIL_API_${REJECTED}`,
    ],
    method: 'GET',
    url: groupServiceAPIUrl,
    data,
  };
}

// get active CDS profile Url
export function getActiveCDSProfile(data) {
  return {
    types: [
      `GET_ACTIVE_CDS_PROFILE_${PENDING}`,
      `GET_ACTIVE_CDS_PROFILE_${FULFILLED}`,
      `GET_ACTIVE_CDS_PROFILE_${REJECTED}`,
    ],
    method: 'GET',
    url: `${getActiveCdsProfileUrl}?profileId=${data}`,
    data,
  };
}

// Validate Email Moblie otp url api

export function validateEmailMobileOTP(data) {
  return {
    types: [
      `VALIDATE_EMAIL_MOBILE_OTP_${PENDING}`,
      `VALIDATE_EMAIL_MOBILE_OTP_${FULFILLED}`,
      `VALIDATE_EMAIL_MOBILE_OTP_${REJECTED}`,
    ],
    method: 'POST',
    url: data.url,
    payload: {},
    data: data.data,
  };
}

// to get profile details in confirm page

export function getProfileDetailsConfirm(data) {
  return {
    types: [
      `GET_PROFILE_DETAIL_CONFIRM_${PENDING}`,
      `GET_PROFILE_DETAIL_CONFIRM_${FULFILLED}`,
      `GET_PROFILE_DETAIL_CONFIRM_${REJECTED}`,
    ],
    method: 'PUT',
    url: getProfileDetails,
    payload: {},
    data,
  };
}

// to sent otp url in confirm page

export function sendOTPUrlCDS(data) {
  return {
    types: [
      `SEND_OTP_URL_${PENDING}`,
      `SEND_OTP_URL_${FULFILLED}`,
      `SEND_OTP_URL_${REJECTED}`,
    ],
    method: 'POST',
    url: sendOTPURL,
    payload: {},
    data,
  };
}

// CDS customer flow actions
// Get subscribe to cds profile
export function getProfileDetailsCDS(data) {
  return {
    types: [
      `GET_PROFILE_DETAILS_${PENDING}`,
      `GET_PROFILE_DETAILS_${FULFILLED}`,
      `GET_PROFILE_DETAILS_${REJECTED}`,
    ],
    method: 'GET',
    url: getProfileDetails,
    payload: {},
    data,
  };
}

// To delete the cds subscripton
export function deleteProfileDetailsCDS(data) {
  return {
    types: [
      `DELETE_PROFILE_DETAILS_${PENDING}`,
      `DELETE_PROFILE_DETAILS_${FULFILLED}`,
      `DELETE_PROFILE_DETAILS_${REJECTED}`,
    ],
    method: 'PUT',
    url: deleteProfileDetails,
    payload: {},
    data,
  };
}

// To get the cds request subscription list

export function getProfileDetailsCDSRequest(data) {
  return {
    types: [
      `GET_PROFILE_DETAILS_CDS_REQUEST_${PENDING}`,
      `GET_PROFILE_DETAILS_CDS_REQUEST_${FULFILLED}`,
      `GET_PROFILE_DETAILS_CDS_REQUEST_${REJECTED}`,
    ],
    method: 'GET',
    url: getProfileDetails,
    payload: {},
    data,
  };
}

// To get the cds request subscription list by status

export function getProfileDetailsCDSRequestByProfileStatus(data) {
  return {
    types: [
      `GET_PROFILE_DETAILS_CDS_REQUEST_BY_STATUS_${PENDING}`,
      `GET_PROFILE_DETAILS_CDS_REQUEST_BY_STATUS_${FULFILLED}`,
      `GET_PROFILE_DETAILS_CDS_REQUEST_BY_STATUS_${REJECTED}`,
    ],
    method: 'GET',
    url: `${getProfileByStatusURL}?profileStatus=${data}`,
    payload: {},
  };
}

// To delete the cds request

export function deleteProfileDetailsCDSRequest(data) {
  return {
    types: [
      `DELETE_PROFILE_DETAILS_CDS_REQUEST_${PENDING}`,
      `DELETE_PROFILE_DETAILS_CDS_REQUEST_${FULFILLED}`,
      `DELETE_PROFILE_DETAILS_CDS_REQUEST_${REJECTED}`,
    ],
    method: 'PUT',
    url: deleteProfileDetails,
    payload: {},
    data,
  };
}

// To get the cds request subscription list by status

export function getProfileBackgroundInprogress(data) {
  return {
    types: [
      `GET_PROFILE_BACKGROUND_INPROGRESS_${PENDING}`,
      `GET_PROFILE_BACKGROUND_INPROGRESS_${FULFILLED}`,
      `GET_PROFILE_BACKGROUND_INPROGRESS_${REJECTED}`,
    ],
    method: 'GET',
    // eslint-disable-next-line max-len
    url: `${profileBackgroundInprogress}?profileId=${data.profileId}&approver=${data.approver}`,
    payload: {},
    data,
  };
}

// To activate the cds profile subscription

export function activateCDSProfile(data) {
  return {
    types: [
      `ACTIVATE_CDS_PROFILE_${PENDING}`,
      `ACTIVATE_CDS_PROFILE_${FULFILLED}`,
      `ACTIVATE_CDS_PROFILE_${REJECTED}`,
    ],
    method: 'POST',
    url: activateProfile,
    payload: {},
    data,
  };
}

// Ticker

export function getTickers() {
  return {
    types: [
      `GET_TICKER_${PENDING}`,
      `GET_TICKER_${FULFILLED}`,
      `GET_TICKER_${REJECTED}`,
    ],
    method: 'GET',
    url: tickerUrl,
    payload: {},
  };
}

export function addTickers(data) {
  return {
    types: [
      `ADD_TICKER_${PENDING}`,
      `ADD_TICKER_${FULFILLED}`,
      `ADD_TICKER_${REJECTED}`,
    ],
    method: 'POST',
    url: tickerUrl,
    payload: {},
    data,
  };
}

export function editTickers(data) {
  return {
    types: [
      `EDIT_TICKER_${PENDING}`,
      `EDIT_TICKER_${FULFILLED}`,
      `EDIT_TICKER_${REJECTED}`,
    ],
    method: 'PUT',
    url: `${tickerUrl}/${data.messageId}`,
    payload: {},
    data,
  };
}

export function deleteTickers(id) {
  return {
    types: [
      `DELETE_TICKER_${PENDING}`,
      `DELETE_TICKER_${FULFILLED}`,
      `DELETE_TICKER_${REJECTED}`,
    ],
    method: 'DELETE',
    url: `${tickerUrl}/${id}`,
    payload: {},
  };
}
